import UserService from '../services/user.service'
import { handleCookieError } from '../utils/utils.js'
import router from '@/router'

const initialState = { 
  status: { loggedIn: false }, 
  user: {}, 
  userList: [], 
  logsList: [], 
  idleVue: {},
  actualSelectedCard: null }

export const userModule = {
  namespaced: true,

  state: initialState,

  actions: {
    async login ({ commit }, user) {
      return UserService.login(user).then(
        response => {
          const user = response.data
          commit('loginSuccess', user)
          sessionStorage.setItem('user', JSON.stringify(user))
          return Promise.resolve(user)
        },
        error => {
          commit('loginFailure')
          return handleCookieError(error, router)
        }
      )
    },
    async relogUserIfNecessary ({ commit }) {
      return UserService.relogUserIfNecessary().then(
        response => {
          const user = response.data
          commit('loginSuccess', user)
          sessionStorage.setItem('user', JSON.stringify(user))
          return Promise.resolve(user)
        },
        error => {
          commit('loginFailure')
          return handleCookieError(error, router)
        }
      )
    },
    async loginAs ({ commit }, user) {
      return UserService.loginAs(user).then(
        response => {
          const userAs = response.data
          commit('loginSuccess', userAs)
          commit('loginAsSuccess')
          sessionStorage.setItem('user', JSON.stringify(userAs))
          return Promise.resolve(userAs)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async releaseRunAs ({ commit }, loginToReturn) {
      return UserService.releaseRunAs(loginToReturn).then(
        response => {
          const user = response.data
          commit('loginSuccess', user)
          commit('releaseAsSuccess')
          sessionStorage.setItem('user', JSON.stringify(user))
          return Promise.resolve(user)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async unblockUser ({ commit }, user) {
      return UserService.unblockUser(user).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async unblockUserAdmin ({ commit }, user) {
      return UserService.unblockUserAdmin(user).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async logout ({ commit }, userToLogOut) {
      return UserService.logout(userToLogOut).then(
        response => {
          commit('logoutSuccess')
          return Promise.resolve(response)
        },
        error => {
          commit('logoutSuccess')
          return handleCookieError(error, router)
        }
      )
    },
    async forceLogout ({ commit }) {
      return UserService.forceLogout().then(
        response => {
          commit('logoutSuccess')
          return Promise.resolve(response)
        },
        error => {
          commit('logoutSuccess')
          return handleCookieError(error, router)
        }
      )
    },
    async getUserList ({ commit }, userSearch) {
      return UserService.getUserList(userSearch).then(
        response => {
          const userList = response.data
          commit('listUserSuccess', userList)
          return Promise.resolve(userList)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getUserListLocked ({ commit }) {
      return UserService.getUserListLocked().then(
        response => {
          const userList = response.data
          return Promise.resolve(userList)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getUserAdminListLocked ({ commit }) {
      return UserService.getUserAdminListLocked().then(
        response => {
          const userList = response.data
          return Promise.resolve(userList)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getRoles ({ commit }) {
      return UserService.getRoles().then(
        response => {
          const rolesList = response.data
          return Promise.resolve(rolesList)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getPeriodes ({ commit }) {
      return UserService.getPeriodes().then(
        response => {
          const periodesList = response.data
          return Promise.resolve(periodesList)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async isPeriodeUpdatable ({ commit }, periodeId) {
      return UserService.isPeriodeUpdatable(periodeId).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getLogs ({ commit }) {
      return UserService.getLogs().then(
        response => {
          const logsList = response.data
          return Promise.resolve(logsList)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async updateMail ({ commit }, updateMail) {
      return UserService.updateMail(updateMail).then(
        response => {
          const mailMaj = response.data
          commit('updateMailSuccess', mailMaj)
          return Promise.resolve(mailMaj)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getFileToDownload ({ commit }, fileName) {
      return UserService.getFileToDownload(fileName).then(
        response => {
          const fileContent = response.data
          return Promise.resolve(fileContent)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getBatchLogs ({ commit }, batchLogs) {
      return UserService.getBatchLogs(batchLogs).then(
        response => {
          const batchLogsList = response.data
          commit('putBatchLogsInStore', batchLogsList)
          return Promise.resolve(batchLogsList)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getListeMajMails ({ commit }) {
      return UserService.getListeMajMails().then(
        response => {
          const listeMajMails = response.data
          return Promise.resolve(listeMajMails)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async createUser ({ commit }, userToCreate) {
      return UserService.createUser(userToCreate).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async editUser ({ commit }, userToUpdate) {
      return UserService.editUser(userToUpdate).then(
        response => {
          const updatedUser = response.data
          commit('editUserSuccess', updatedUser)
          return Promise.resolve(updatedUser)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async deleteUser ({ commit }, userToDelete) {
      return UserService.deleteUser(userToDelete).then(
        response => {
          commit('deleteUserList')
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async generateLogin ({ commit }, userToCreate) {
      return UserService.generateLogin(userToCreate).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async printDoc ({ commit }, docPrinterBean) {
      return UserService.printDoc(docPrinterBean).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async lockUser ({ commit }, userToLock) {
      return UserService.lockUser(userToLock).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async initXarmConf ({ commit }, userXarmConfigToInit) {
      return UserService.initXarmConf(userXarmConfigToInit).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async deleteXarmConf ({ commit }, userXarmConfigToDelete) {
      return UserService.deleteXarmConf(userXarmConfigToDelete).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async resetPassword ({ commit }, userToUpdate) {
      return UserService.resetPassword(userToUpdate).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async checkIfUserLocked ({ commit }, userToCheck) {
      return UserService.checkIfUserLocked(userToCheck).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async checkIfXarmConfigNotInitialized ({ commit }, userToCheck) {
      return UserService.checkIfXarmConfigNotInitialized(userToCheck).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getEntrepriseById ({ commit }, rechercheEntreprise) {
      return UserService.getEntrepriseById(rechercheEntreprise).then(
        response => {
          const entreprise = response.data
          commit('putEntrepriseInStore', entreprise)
          return Promise.resolve(entreprise)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async changePassword ({ commit }, changePasswordUser) {
      return UserService.changePassword(changePasswordUser).then(
        response => {
          const user = response.data
          commit('loginSuccess', user)
          return Promise.resolve(user)
        },
        error => {
          commit('loginFailure')
          return handleCookieError(error, router)
        }
      )
    },
    async checkHistory ({ commit }, changePasswordUser) {
      return UserService.checkHistory(changePasswordUser).then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async infoAccueil ({ commit }) {
      return UserService.getInfoAccueil().then(
        response => {
          commit('infoAccueil', response.data)
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    async getTokenForMessagerie ({ commit }, login) {
      return UserService.getTokenForMessagerie(login).then(
        response => {
          return Promise.resolve(response.data)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    },
    selectEntreprise ({ commit }, entreprise) {
      commit('putEntrepriseInStore', entreprise)
    },
    selectUserToReturn ({ commit }, loginToReturn) {
      commit('putUserToReturn', loginToReturn)
    },
    selectPeriode ({ commit }, periode) {
      commit('putPeriodeInStore', periode)
    },
    deleteUserList ({ commit }) {
      commit('deleteUserList')
    },
    selectActualCard ({ commit }, actualCard) {
      commit('putActualCardInStore', actualCard)
    },
    deleteBatchLogsList ({ commit }) {
      commit('deleteBatchLogsList')
    },
    userConnectionToMessagerie ({ commit }, isUserConnected) {
      commit('userConnectionToMessagerie', isUserConnected)
    }
  },
  mutations: {
    loginSuccess (state, user) {
      state.status.loggedIn = true
      state.user = user
    },
    loginAsSuccess (state) {
      state.isRunAsLaunched = true
    },
    releaseAsSuccess (state) {
      state.isRunAsLaunched = false
    },
    loginFailure (state) {
      state.status.loggedIn = false
      state.user = null
    },
    logoutSuccess (initialState) {
      initialState.isRunAsLaunched = false
      initialState.status.loggedIn = false
      initialState.user = null
      initialState.userList = []
      sessionStorage.clear()
    },
    putBatchLogsInStore (state, batchLogsList) {
      state.batchLogsList = batchLogsList
    },
    putEntrepriseInStore (state, entreprise) {
      state.user.selectedEntreprise = entreprise
    },
    putUserToReturn (state, loginToReturn) {
      state.loginToReturn = loginToReturn
    },
    putPeriodeInStore (state, periode) {
      state.user.selectedPeriode = periode
    },
    listUserSuccess (state, userList) {
      state.userList = userList.users
      state.userListNbResults = userList.nbResults
    },
    updateMailSuccess (state, mailMaj) {
      state.user.emailPro = mailMaj
    },
    deleteUserList (state) {
      state.userList = []
    },
    deleteBatchLogsList (state) {
      state.batchLogsList = []
    },
    userConnectionToMessagerie (state, isUserConnected) {
      state.user.connectedToMessagerie = isUserConnected
    },
    putActualCardInStore (state, actualCard) {
      state.actualSelectedCard = actualCard
    },
    editUserSuccess (state, updatedUser) {
      if (state.user.personneId === updatedUser.personneId) {
        state.user.groupe = updatedUser.groupe
        state.user.civilite = this.selectedCivility
        state.user.prenom = updatedUser.firstName
        state.user.nom = updatedUser.lastName
        state.user.telephone = updatedUser.phone
        state.user.fax = updatedUser.fax
        state.user.emailPro = updatedUser.emailPro
        state.user.adresse = updatedUser.address
        state.user.adresseComplement = updatedUser.addressComplement
        state.user.codePostal = updatedUser.zipCode
        state.user.ville = updatedUser.city
        state.user.pays = updatedUser.country
        state.user.dateEnvoieLogin = updatedUser.dateEnvoiLogin
        state.user.dateEnvoiePassword = updatedUser.dateEnvoiPassword
        state.user.nbEssaisQuestionSecrete = updatedUser.secretResponseTryNbr
        state.user.adminRestricted = updatedUser.adminRestricted
        state.user.logsAdminAccess = updatedUser.logsAdminAccess
        state.user.restrictionList = updatedUser.restrictionList
      }
    },
    infoAccueil (state, actualite) {
      state.actualiteAccueil = actualite
    }
  }
}
